module.exports = __webpack_public_path__ + "static/img/10.ebd92e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/8/zh/10.png
// module id = ohrI
// module chunks = 0